module.exports = __webpack_public_path__ + "img/sp_article_5.a52d71f2.jpg";